import { useEffect } from "react";

// Adds the "visible" class to every ".reveal" section once it scrolls into view.
export function useReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const observeAll = () =>
      document
        .querySelectorAll(".reveal:not([data-revealed])")
        .forEach((el) => {
          el.setAttribute("data-revealed", "1");
          observer.observe(el);
        });
    observeAll();

    /* below-the-fold screens mount lazily — pick their sections up too */
    const mo = new MutationObserver(observeAll);
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      mo.disconnect();
      observer.disconnect();
    };
  }, []);
}
